import { useAppSelector } from 'hooks/reduxHooks'
import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import { getLoyaltyEsimInclusion } from 'loyalty/constants/loyaltyEsimInclusion'
import type { LoyaltyEligibleOfferOrProperty } from 'loyalty/lib/esims/esimOfferEligibility'
import { getIsOfferEsimEligible, getIsTourVariationEsimEligible } from 'loyalty/lib/esims/esimOfferEligibility'
import useLoyaltyUserBenefitView from 'loyalty/hooks/useLoyaltyUserBenefitView'

function useLoyaltyEsimDescription(): string | undefined {
  const intl = useIntl()
  const benefit = useLoyaltyUserBenefitView('esim_package')
  const gbValue = benefit?.benefit?.value?.amount
  if (!gbValue) return undefined
  return intl.formatMessage({
    id: '32-2_QywbIiWzV7edOop',
    defaultMessage: '{gbValue}GB Free Data Roaming',
  }, { gbValue })
}

export default function useLoyaltyEsimInclusion(offerOrProperty: LoyaltyEligibleOfferOrProperty | undefined): App.OfferInclusion | undefined {
  const isEsimEligible = useAppSelector((state) => (offerOrProperty ? getIsOfferEsimEligible(state, offerOrProperty) : false))
  const description = useLoyaltyEsimDescription()

  return useMemo(() => {
    if (!offerOrProperty || !isEsimEligible || !description) return undefined
    return getLoyaltyEsimInclusion(description)
  }, [offerOrProperty, isEsimEligible, description])
}

/**
 * Tour-variation counterpart of useLoyaltyEsimInclusion.
 * Returns the synthetic eSIM OfferInclusion when the variation is eSIM-eligible, undefined otherwise.
 */
export function useTourVariationLoyaltyEsimInclusion(
  variation: App.Tours.TourV2OfferVariation | undefined,
): App.OfferInclusion | undefined {
  const isEsimEligible = useAppSelector((state) => (variation ? getIsTourVariationEsimEligible(state, variation) : false))
  const description = useLoyaltyEsimDescription()

  return useMemo(() => {
    if (!variation || !isEsimEligible || !description) return undefined
    return getLoyaltyEsimInclusion(description)
  }, [variation, isEsimEligible, description])
}
